// extracted by mini-css-extract-plugin
module.exports = {"container":"ChipsInput_container__2QLTU","chip":"ChipsInput_chip__3B-Qm","close":"ChipsInput_close__2oGhz","form":"ChipsInput_form__3UWQI","input":"ChipsInput_input__20SIG"};